import { Progress, Section } from "react-bulma-components";

export default function LoadingIndicator() {
    return (
        <Section>
            <Progress color="info" size="small" />
        </Section>
    );
}
